import { render, staticRenderFns } from "./g-uuid.vue?vue&type=template&id=5576bb14&scoped=true&"
import script from "./g-uuid.vue?vue&type=script&lang=js&"
export * from "./g-uuid.vue?vue&type=script&lang=js&"
import style0 from "./g-uuid.vue?vue&type=style&index=0&id=5576bb14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5576bb14",
  null
  
)

export default component.exports